import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'chatFilter'
})
export class ChatFilterPipe implements PipeTransform {

  transform(items: any[], searchText: any): unknown {
    if (!searchText)  return items;
      searchText = searchText.toLowerCase();
      let filteredItems = items.filter(it => it.firstName.toLowerCase().includes(searchText) )
    return filteredItems;
  }

}
